import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Card } from 'reactstrap';
import './SettingsCard.scss';
import DefaultContent from './DefaultContent';

const SettingsCard = ({
  iconClassName, title, paragraph, status, done, size, className, href, children, id,
}) => {
  const Tag = href && !done ? Link : 'div';
  const iconSize = {
    'font-24': size === 'small',
    'font-48': size === 'big',
  };

  const getParagraph = () => {
    switch (status) {
      case 'pending':
        return 'Account.investor-details-check';

      case 'updates-required':
        return 'Update required - Check status';

      case 'service-denied':
        return 'Service denied';

      default: return '';
    }
  };

  return (
    <Card className={classNames('set-card', 'mb-0', `card-${size}`, className, {
      'set-card--denied': status === 'service-denied',
      'set-card--pending': ['pending', 'updates-required'].includes(status),
      'set-card--done': done,
    })}
    >
      <Tag id={id} className="d-flex p-0 align-items-center card-body" to={href && !done ? href : null}>
        {iconClassName && (
          <div
            className={classNames('set-card_icon d-flex align-items-center justify-content-center', {
              'font-24': size === 'small',
              'font-32': size === 'big',
            })}
          >
            <i className={classNames(iconClassName, 'icon-text-inherit')} />
          </div>
        )}
        <div className="set-card_data d-flex flex-column justify-content-start font-24">
          {children || (
            <DefaultContent
              paragraph={!status ? paragraph : getParagraph()}
              status={!!done}
              size={size}
              title={title}
            />
          )}
        </div>
        <div
          className={classNames('set-card_status d-flex align-items-center justify-content-center mr-1', iconSize)}
        >
          {
            done
              ? <i className="icon-check icon-text-inherit" />
              : (['pending', 'service-denied', 'updates-required'].includes(status))
                ? (
                  <i className={classNames('icon-faq', {
                    'set-card--denied__status': status === 'service-denied',
                    'set-card--pending__status': ['pending', 'updates-required'].includes(status),
                  })}
                  />
                )
                : <i className="icon-arrow_right" />
          }
        </div>
      </Tag>
    </Card>
  );
};

SettingsCard.defaultProps = {
  done: false,
  status: '',
  className: '',
  paragraph: '',
  title: '',
  href: '',
  iconClassName: '',
  size: 'small',
  children: null,
};

SettingsCard.propTypes = {
  done: PropTypes.bool,
  iconClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  paragraph: PropTypes.string,
  status: PropTypes.string,
  size: PropTypes.oneOf(['small', 'big']),
  className: PropTypes.string,
  href: PropTypes.string,
  children: PropTypes.element,
};

export default SettingsCard;
